import React, { useEffect, useState, useRef } from 'react';
import '../styles/ConversationsDash.css';
import '../styles/BannersDash.css';
import { FaPlusCircle, FaSearch, FaCalendarAlt } from 'react-icons/fa';
import axios from 'axios';
import config from '../../../constants/config';
import { RiCheckFill, RiCloseFill, RiFileShield2Line, RiToggleFill, RiToggleLine, RiDeleteBin6Line } from 'react-icons/ri';
import { useSlideout } from '../../../hooks/SlideoutContext';
import { IoMdRefresh } from 'react-icons/io';
import axiosPost from '../../../helper/axios-helper';

export default function ConversationsDash() {
    const [conversations, setConversations] = useState([]);
    const [upcomingConversations, setUpcomingConversations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [viewMode, setViewMode] = useState('past'); // 'past' or 'upcoming'
    const { openSlideout, closeSlideout } = useSlideout();
    
    useEffect(() => {
        fetchConversations();
        fetchUpcomingConversations();
    }, [])

    const fetchConversations = () => {
        axiosPost('conversations/fetch', {}, {}, (data) => {
            const { success, response } = data;

            if (success) {
                setConversations(data.data);
                console.log(data.data);
            } else {
                console.log(response);
            }
        });
    }
    
    const fetchUpcomingConversations = () => {
        axiosPost('conversations/upcoming/fetch', {}, {}, (data) => {
            const { success, response } = data;

            if (success) {
                setUpcomingConversations(data.data);
                console.log(data.data);
            } else {
                console.log(response);
            }
        });
    }
    
    const handleDeleteConversation = (id) => {
        if (window.confirm('Are you sure you want to delete this conversation?')) {
            const formData = new FormData();
            formData.append('id', id);

            axios.post(config.api.url + "admin/conversations/delete", formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: "b8GjLbLHDX9isF10ptWj",
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((json) => {
                const { success, response } = json.data;
                if (success) {
                    if (viewMode === 'past') {
                        fetchConversations();
                    } else {
                        fetchUpcomingConversations();
                    }
                } else {
                    console.log("Error:", response);
                    alert("Failed to delete conversation");
                }
            })
            .catch((error) => {
                console.error("Delete error:", error);
                alert("Failed to delete conversation");
            });
        }
    };
    
    const fetchUpcomingConversationsOld = () => {
        // This would normally be an API call, but we'll use mock data for now
        const mockUpcomingConversations = [
            {
                id: 101,
                title: "Future of 5G in the Caribbean",
                subtitle: "Join industry leaders to discuss the implementation and future of 5G technology across Caribbean nations. Learn about challenges, opportunities, and strategic roadmaps.",
                c2a: "Register Now",
                image: "https://images.unsplash.com/photo-1562408590-e32931084e23?q=80&w=2670&auto=format&fit=crop",
                date: "2025-08-15",
                time: "10:00 AM - 12:00 PM",
                location: "Virtual Event"
            },
            {
                id: 102,
                title: "Cybersecurity Summit 2025",
                subtitle: "Explore the latest trends in cybersecurity with a focus on telecommunications infrastructure protection. Expert panels and hands-on workshops included.",
                c2a: "Save Your Spot",
                image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?q=80&w=2670&auto=format&fit=crop",
                date: "2025-09-22",
                time: "9:00 AM - 4:00 PM",
                location: "Kingston, Jamaica"
            },
            {
                id: 103,
                title: "Digital Transformation in Telecom",
                subtitle: "A comprehensive look at how digital transformation is reshaping the telecommunications industry in our region. Case studies and success stories from leading providers.",
                c2a: "Learn More",
                image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=2670&auto=format&fit=crop",
                date: "2025-10-05",
                time: "1:00 PM - 3:30 PM",
                location: "Nassau, Bahamas"
            },
            {
                id: 104,
                title: "Regulatory Frameworks Workshop",
                subtitle: "Understanding the evolving regulatory landscape for telecommunications in the Caribbean. Interactive sessions with policy makers and industry experts.",
                c2a: "Register Interest",
                image: "https://images.unsplash.com/photo-1521791055366-0d553872125f?q=80&w=2669&auto=format&fit=crop",
                date: "2025-11-18",
                time: "10:30 AM - 2:30 PM",
                location: "Port of Spain, Trinidad"
            }
        ];
        
        // Simulate API delay
        setTimeout(() => {
            setUpcomingConversations(mockUpcomingConversations);
        }, 300);
    }
    
    const EditConversation = ({ conversation }) => {
        const { closeSlideout } = useSlideout();
        const [conversationData, setConversationData] = useState({
            id: conversation.id,
            title: conversation.title,
            subtitle: conversation.subtitle,
            c2a: conversation.c2a || "",
            image: conversation.image
        });

        const [selectedImageFile, setSelectedImageFile] = useState(null);
        const [selectedImagePreview, setSelectedImagePreview] = useState(conversation.image);
        const fileInputRef = useRef(null);

        // Handle input changes
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setConversationData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
        };

        // Handle file selection
        const handleImageChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                const imageUrl = URL.createObjectURL(file);
                setSelectedImageFile(file);
                setSelectedImagePreview(imageUrl);
            }
        };

        // Open file input
        const handleSelectImage = () => {
            fileInputRef.current.click();
        };

        // Handle save changes
        const handleSaveChanges = () => {
            const formData = new FormData();
            formData.append("id", conversationData.id);
            formData.append("title", conversationData.title);
            formData.append("subtitle", conversationData.subtitle);
            formData.append("c2a", conversationData.c2a);

            if (selectedImageFile) {
                formData.append("image", selectedImageFile);
            }

            axios.post(config.api.url + "admin/conversations/update", formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: "b8GjLbLHDX9isF10ptWj",
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((json) => {
                const { success, response } = json.data;
                if (success) {
                    closeSlideout();
                    fetchConversations();
                } else {
                    console.log("Error:", response);
                }
            })
            .catch((error) => {
                console.error("Update error:", error);
            });
        };

        return (
            <div className="EditBannerContainer">
                <div className="EditBannerOptions">
                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Conversation Image</div>
                        <div className="EditBannerOptionContent">
                            <div 
                                className="EditBannerImagePreview" 
                                style={{ backgroundImage: `url(${selectedImagePreview})` }}
                                onClick={handleSelectImage}
                            ></div>
                            <input 
                                type="file" 
                                ref={fileInputRef} 
                                style={{ display: 'none' }} 
                                onChange={handleImageChange} 
                                accept="image/*"
                            />
                            <div className="EditBannerImageText">Click to change image</div>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Title</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="title" 
                                value={conversationData.title} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Description</div>
                        <div className="EditBannerOptionContent">
                            <textarea 
                                name="subtitle" 
                                value={conversationData.subtitle} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                rows="6"
                                style={{ resize: 'vertical' }}
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Call to Action URL</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="c2a" 
                                value={conversationData.c2a} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="https://example.com"
                            />
                        </div>
                    </div>

                    <div className="EditBannerActions">
                        <button 
                            className="EditBannerSaveButton" 
                            onClick={handleSaveChanges}
                        >
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        );
    };
    
    const AddConversation = () => {
        const { closeSlideout } = useSlideout();
        const [conversationData, setConversationData] = useState({
            title: "",
            subtitle: "",
            c2a: "",
            datetime: "",
            isUpcoming: viewMode === 'upcoming'
        });

        const [selectedImageFile, setSelectedImageFile] = useState(null);
        const [selectedImagePreview, setSelectedImagePreview] = useState("");
        const fileInputRef = useRef(null);

        // Handle input changes
        const handleChange = (e) => {
            const { name, value, type, checked } = e.target;
            setConversationData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value
            }));
        };

        // Handle file selection
        const handleImageChange = (event) => {
            const file = event.target.files[0];
            if (file) {
                const imageUrl = URL.createObjectURL(file);
                setSelectedImageFile(file);
                setSelectedImagePreview(imageUrl);
            }
        };

        // Open file input
        const handleSelectImage = () => {
            fileInputRef.current.click();
        };

        // Handle save changes
        const handleSaveChanges = () => {
            if (!selectedImageFile) {
                alert("Please select an image");
                return;
            }

            if (!conversationData.datetime) {
                alert("Please select a date and time");
                return;
            }

            const formData = new FormData();
            formData.append("title", conversationData.title);
            formData.append("subtitle", conversationData.subtitle);
            formData.append("c2a", conversationData.c2a);
            formData.append("image", selectedImageFile);
            
            // Convert datetime to Unix timestamp
            const timestamp = Math.floor(new Date(conversationData.datetime).getTime() / 1000);
            formData.append("timestamp", timestamp);

            axios.post(config.api.url + "admin/conversations/add", formData, {
                crossdomain: true,
                headers: {
                    api: config.api.key,
                    auth: "b8GjLbLHDX9isF10ptWj",
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((json) => {
                const { success, response } = json.data;
                if (success) {
                    closeSlideout();
                    if (viewMode === 'past') {
                        fetchConversations();
                    } else {
                        fetchUpcomingConversations();
                    }
                } else {
                    console.log("Error:", response);
                }
            })
            .catch((error) => {
                console.error("Add error:", error);
            });
        };

        return (
            <div className="EditBannerContainer">
                <div className="EditBannerOptions">
                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Conversation Image</div>
                        <div className="EditBannerOptionContent">
                            <div 
                                className="EditBannerImagePreview" 
                                style={selectedImagePreview ? { backgroundImage: `url(${selectedImagePreview})` } : { backgroundColor: '#f0f0f0' }}
                                onClick={handleSelectImage}
                            >
                                {!selectedImagePreview && <div className="NoImageText">Click to add image</div>}
                            </div>
                            <input 
                                type="file" 
                                ref={fileInputRef} 
                                style={{ display: 'none' }} 
                                onChange={handleImageChange} 
                                accept="image/*"
                            />
                            <div className="EditBannerImageText">Click to select image</div>
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Title</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="title" 
                                value={conversationData.title} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="Enter conversation title"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Description</div>
                        <div className="EditBannerOptionContent">
                            <textarea 
                                name="subtitle" 
                                value={conversationData.subtitle} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                rows="6"
                                style={{ resize: 'vertical' }}
                                placeholder="Enter conversation description"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Call to Action URL</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="text" 
                                name="c2a" 
                                value={conversationData.c2a} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                                placeholder="https://example.com"
                            />
                        </div>
                    </div>

                    <div className="EditBannerOption">
                        <div className="EditBannerOptionTitle">Event Date & Time</div>
                        <div className="EditBannerOptionContent">
                            <input 
                                type="datetime-local" 
                                name="datetime" 
                                value={conversationData.datetime} 
                                onChange={handleChange} 
                                className="EditBannerInput"
                            />
                            <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                {viewMode === 'upcoming' ? 'Set a future date for upcoming conversations' : 'Set the date when this conversation occurred'}
                            </small>
                        </div>
                    </div>

                    <div className="EditBannerActions">
                        <button 
                            className="EditBannerSaveButton" 
                            onClick={handleSaveChanges}
                        >
                            Add Conversation
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className='BannersDash'>
            <div className='BannersHeader'>
                <div className='BannersHeaderTitle'>
                    <h1>CANTO Conversations</h1>
                    <p>Manage CANTO Conversations that appear on your website</p>
                </div>
                <div className='BannersHeaderActions'>
                    <div className='ConversationsToggle'>
                        <button 
                            className={`ConversationsToggleButton ${viewMode === 'past' ? 'active' : ''}`}
                            onClick={() => setViewMode('past')}
                        >
                            Past
                        </button>
                        <button 
                            className={`ConversationsToggleButton ${viewMode === 'upcoming' ? 'active' : ''}`}
                            onClick={() => setViewMode('upcoming')}
                        >
                            Upcoming
                        </button>
                    </div>
                    <button 
                        className='BannersRefreshButton' 
                        onClick={viewMode === 'past' ? fetchConversations : fetchUpcomingConversations}
                    >
                        <IoMdRefresh />
                        <span>Refresh</span>
                    </button>
                    <button 
                        className='BannersAddButton'
                        onClick={() => {
                            openSlideout({
                                title: `Add New ${viewMode === 'upcoming' ? 'Upcoming ' : ''}Conversation`,
                                content: <AddConversation />
                            });
                        }}
                    >
                        <FaPlusCircle />
                        <span>Add New</span>
                    </button>
                </div>
            </div>

            <div className='BannersContent'>
                <div className='BannersContentNavigation'>
                    <div className='BannersContentNavigationItem Image'>Image</div>
                    <div className='BannersContentNavigationItem Title'>Title</div>
                    <div className='BannersContentNavigationItem Subtitle'>Description</div>
                    {viewMode === 'upcoming' && (
                        <div className='BannersContentNavigationItem Date'>Date</div>
                    )}
                </div>
                <div className='BannersScroll'>
                    {(viewMode === 'past' ? conversations : upcomingConversations).map((conversation, index) => {
                        return (
                            <div className='BannerItem' key={conversation.id}>
                                <div className="BannerItemDetailsText Image">
                                    <div 
                                        className="BannerItemDetailsTextImage" 
                                        style={{ backgroundImage: `url(${conversation.image})` }} 
                                    />
                                </div>
                                <div className="BannerItemDetailsText Title Bold">{conversation.title}</div>
                                <div className="BannerItemDetailsText Subtitle">
                                    {conversation.subtitle.length > 100 
                                        ? `${conversation.subtitle.substring(0, 100)}...` 
                                        : conversation.subtitle}
                                </div>
                                {viewMode === 'upcoming' && conversation.timestamp && (
                                    <div className="BannerItemDetailsText Date">
                                        <div><FaCalendarAlt /> {new Date(conversation.timestamp * 1000).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}</div>
                                    </div>
                                )}

                                <div className="BannerItemOptions">
                                    <a 
                                        onClick={() => {
                                            openSlideout({
                                                title: 'Edit Conversation',
                                                content: <EditConversation conversation={conversation} />
                                            });
                                        }} 
                                        className="BannerItemOptionsButton Edit"
                                    >
                                        <RiFileShield2Line style={{ fontSize: 14 }} />
                                        <span className="BannerItemOptionsButtonText">Edit</span>
                                    </a>
                                    <a 
                                        onClick={() => handleDeleteConversation(conversation.id)} 
                                        className="BannerItemOptionsButton Delete"
                                    >
                                        <RiDeleteBin6Line style={{ fontSize: 14 }} />
                                        <span className="BannerItemOptionsButtonText">Delete</span>
                                    </a>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className='BannersPaginationWrapper'>
                    {/* Pagination will be added here when needed */}
                </div>
            </div>
        </div>
    );
}

